import React from 'react';
import { BgImage } from './Img';

// Inner-page hero: real photo background, title and optional subtitle / extra content.
const PageHero = ({ image, position = 'center', title, subtitle, minHeight = '52vh', children }) => (
  <section className="hero" style={{ minHeight }}>
    <BgImage image={image} position={position} priority />
    <div className="hero-content">
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
      {children}
    </div>
  </section>
);

export default PageHero;
